export enum PaymentType {
    None,
    Invoice,
}
